/* __next_internal_client_entry_do_not_use__ TextLink auto */ import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import styled from "styled-components";
import { Link } from "../LinkAnchor";
import { onClickTextAction, TextAction } from "./common";
var StyledLink = styled(Link).withConfig({
    componentId: "sc-228f427a-0"
})([
    "display:inline-block;width:fit-content;"
]); // This element is being uncooperative
/**
 * @deprecated use EmbeddedLink from faire/web/ui/EmbeddedLink for text inside of Typography,
 *             or a Button with variant="tertiary" from @faire/web--source/slate/Button otherwise.
 * @supersededBy "@faire/web--source/slate/Button/Button#Button"
 * @trackcomponent
 */ export var TextLink = function(_param) {
    var postEventButtonId = _param.postEventButtonId, onClick = _param.onClick, icon = _param.icon, animate = _param.animate, color = _param.color, hoverColor = _param.hoverColor, children = _param.children, typographyStyles = _param.typographyStyles, props = _object_without_properties(_param, [
        "postEventButtonId",
        "onClick",
        "icon",
        "animate",
        "color",
        "hoverColor",
        "children",
        "typographyStyles"
    ]);
    return /*#__PURE__*/ _jsx(StyledLink, _object_spread_props(_object_spread({
        onClick: onClickTextAction(onClick, postEventButtonId)
    }, props), {
        children: /*#__PURE__*/ _jsx(TextAction, {
            animate: animate,
            color: color,
            hoverColor: hoverColor,
            icon: icon,
            typographyStyles: typographyStyles,
            children: children
        })
    }));
};
